<template lang="html">
  <v-page :profile="profile">
    <v-container>
      <v-vibbrant-profile :user="vibbrante" />
    </v-container>
  </v-page>
</template>

<script>
import VibbrantProfile from '@/parts/modules/vibbrant-profile';
import publicApi from '@/api/public';

export default {
  components: {
    'v-vibbrant-profile': VibbrantProfile,
  },
  props: {
    vibbrante: Object,
    profile: {
      default: 'client',
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    click() {
      this.$emit('click');
    },
    fetchData() {
      publicApi
        .profile(this.$route.params.id)
        .then(response => {
          this.vibbrante = response.data;
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
  computed: {
    theClass() {
      return 'type-' + config.profile.names[this.user.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/pages/vibbrante-profile-public.vue